import { render } from "./musicNote.vue?vue&type=template&id=50fd5c65"
const script = {}
script.render = render

export default script